import React, { useEffect, useState } from "react";
/* import Typography from "@mui/material/Typography";
import Popper from "@mui/material/Popper";
import PopupState, { bindToggle, bindPopper } from "material-ui-popup-state";
import Fade from "@mui/material/Fade";
import Paper from "@mui/material/Paper"; */
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
//import { FunctionComponent, useEffect, useState } from "react";
import { ArtifactResponse } from "../../interfaces/components/history-artifacts/historyArtifacts.interface";
export default function PopperPopupState() {
  const [userid, setUserid] = React.useState("");
  const [sid, setSid] = React.useState("");
  const [refreshKey, setRefreshKey] = useState(0);

  function firestoreCompare(a: ArtifactResponse, b: ArtifactResponse) {
    if (a.time < b.time) {
      return -1;
    }
    if (a.time > b.time) {
      return 1;
    }
    return 0;
  }

  async function getBucketMostRecentFile() {
    const uid =
      window.sessionStorage.getItem("uid") === null
        ? "JEVZyG7f36S8BPNE6kSTryos43t1"
        : window.sessionStorage.getItem("uid");
    const creds = {
      type: "service_account",
      project_id: "nexum-chatbot-294014",
      private_key_id: "36da7ad6c0d783d6eb8133c6f8397fb4ef848885",
      private_key:
        "-----BEGIN PRIVATE KEY-----\nMIIEvQIBADANBgkqhkiG9w0BAQEFAASCBKcwggSjAgEAAoIBAQDINjfVnsy9pG+4\n4JeVhomHsPUNOjERHb4ZBPOV6mnlJXD0y3wZDy9BH8IqZCpnhmx3i50XXhCmPViZ\nbppMsXh67v5PqHPWt58b9swufgDIinIR8bbTp2sgisk3ZjN/Bho/5+rJc4kPDfd0\nyrzRGyhMYy9YyjRzaV/JhEGc0kYa0pqf3V72cnuCKc1ahLBC5RV/F6BCZMxUpaHx\nFE+sTZ8ZRFHkigvQ35xs6EIzJzmWUM5pM+LcEAc7Laxc4sCxcnn+uJbNJy6l08Nn\n/dQUYp076QX7aHTSsSWK3wfDK1pvoQ+AuVv0Qv6ObEiWqrTBibFFir8YusTp9CY6\nepJwYVXHAgMBAAECggEADYlU5xWQhDXs89QDi7GH9Ouq9dT8YkrfgnOKQJWTyVFp\nvLNRVaRoLoAGMbWKBGvbQ43l9iF/AK5fIiiPOCY7nhwwh5Q9GMRbdpmOHoqYZPav\nVbVBBjhojs+zYRKA4tK3zaBRiINOPf1UwMnAUGcEp32BQwCQ4Ui7mDVf9kllQgTi\nc0wF0+7gmfUiOcaG3e5LkIQ/41wnw6TYH4wfxdY3mB7lQCTslLWupVfziufO2vM1\na/35avYAwqahWAjb16we06ROLbfmYR/S1TTgsoWlZGiY7t8ry142XS8cjdaaug3M\n2RnZao1f//74zK3hUxIvaM/gCL5t6dID4pAdP6JFUQKBgQD7/5F/4PZAVJp0lYFw\nkdCk/+3d2ttYvk9YjZ0egGgNAyQQoEfwevzWpKN9lWhYL0N2eQz86mFBbOb4E+Ji\n2WhtD34Ve5tiX3JnhvhFMt6AS4z9D4wIPOWmdVj3DCTPg0CmiNjhnVqnBTNY2QSf\nIW9tuWVPKTHQoQQ5fvV8c9uLLwKBgQDLZCAg8yBWoWnl6yiIwBeH2T6mhZPJOJda\nwZD/t/GBT+4kjN77LRTmigK88L9qDclSNPBVzL2FdvS43mUwzoIxdj2T3OTwUzHQ\nD/OYgZcRcEYAv3vm3PkYoGMC2hXvljQ3zsI7V39VUbPV0fI7PVYIcatAo+GK8nPX\ncB+zueDY6QKBgGpRXw+21+44Q5ogYaYevwp+N9s8NQLx+AQCa2GtBzlGM/cXyII7\nQWVFvPyFBqr99daMJ+Ck+jdiPOg5a3ANDbPFr4pcxifw4RGwrhpz5c/3EBrMbmYj\nWziplclVREqQs7wPTIGTo+WHmixIE10X/C0s5QNK/Atrg57GY8gIEX5dAoGBAMa0\ndDscrBxWqBoKy1gGqzZ6RJ31ZHOzCROOhnV+JMCb8WHeCr7DxWaRsKkcXzVicKwS\nsjZwxzuMAvxVsfCj4EgoZ3J83WH5NXI7E1aMTKWp1YpHiOn8OpQXpYOUwteGHE/l\nfJbzHaCiKJqd+RRtEQ9A1flZ4jCYPBpfHWm+EHB5AoGAFP/OAhBsPB7RomWYyrfj\nKcTr5oxqA61rOirX7+XuVpPnnglbWMjk6++P1bUgAxSRq5OPNgtdSs46xeU7jCDO\n8SyURSdX9AqVxwprEHotFbBD+8duvsfpSCL3yjamTfozDLmyeUliT9qryBRFtqOy\nLgsdJEoqKxsXcF5Khj1aK50=\n-----END PRIVATE KEY-----\n",
      client_email: "nexum-chatbot-294014@appspot.gserviceaccount.com",
      client_id: "111592578438447854919",
      auth_uri: "https://accounts.google.com/o/oauth2/auth",
      token_uri: "https://oauth2.googleapis.com/token",
      auth_provider_x509_cert_url: "https://www.googleapis.com/oauth2/v1/certs",
      client_x509_cert_url:
        "https://www.googleapis.com/robot/v1/metadata/x509/nexum-chatbot-294014%40appspot.gserviceaccount.com",
    };

    const firebaseConfig = {
      apiKey: "AIzaSyBr365v4b2bX3rAxt3Dh8OXsYaHvv1Zm3A",
      authDomain: `${creds.project_id}.firebaseapp.com`,
      databaseURL: `https://${creds.project_id}.firebaseio.com`,
      projectId: creds.project_id,
      storageBucket: `${creds.project_id}.appspot.com`,
      messagingSenderId: "828621662226",
      appId: "1:828621662226:web:6c88466e9aac81eda450cb",
    };
    firebase.initializeApp(firebaseConfig);
    let db = firebase.firestore();
    var conversationsList: Array<ArtifactResponse> = [];
    await db
      .collection("users")
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          if (
            doc.data().arrayConversationId[0] !== undefined &&
            doc.data().arrayConversationId[0].user_id === uid
          )
            conversationsList = doc.data().arrayConversationId;
        });
      });
    conversationsList.sort(firestoreCompare);
    var actualConversation = conversationsList[conversationsList.length - 1];
    var userid = actualConversation.user_id;
    var sid = actualConversation.conversation_id;

    return [userid, sid];
  }

  async function getNewestUploadedFile() {
    var info = await getBucketMostRecentFile();
    setUserid(String(info[0]));
    setSid(String(info[1]));
  }

  // loading automatic diagram in 10 second
  useEffect(() => {
    getNewestUploadedFile();
    const intervalId = setInterval(refreshEmbed, 10000);
    return () => clearInterval(intervalId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  function refreshEmbed() {
    setRefreshKey((prevKey) => prevKey + 1);
  }
  return (
    <div>
      <button
        style={{ cursor: "pointer" }}
        className="link-button3"
        onClick={refreshEmbed}
      >
        Refresh Diagram
      </button>
      <embed
        key={refreshKey}
        src={`https://viewer.diagrams.net/?lightbox=1&highlight=0000ff&edit=_blank&page=1&layers=1&nav=1&title=#Uhttps%3A%2F%2Fstorage.googleapis.com%2F${process.env.REACT_APP_STORAGE_BUCKET}%2F${userid}%2F${sid}%2Fuser-diagram.xml`}
        type="application/xml"
        width="900"
        height="600"
      />
    </div>
  );
}
